// People To Inform Reducer

const peopleToInformDefaultState = {
    list : []
};

export default (state = peopleToInformDefaultState, action) => {
    switch (action.type) {
        case 'SET_PEOPLE_TO_INFORM':
            return {
                ...state,
                list : action.data
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/peopleToInform.js